import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const configErrorTypeValues = [
  "UNKNOWN",
  "GLOBAL_APP_SETTING_NOT_FOUND",
  "QUEUE_DEFINITION_NOT_FOUND",
  "INNGEST_UNAVAILABLE_IN_TRAINING_SANDBOX",
] as const;
const configErrorTypeSchema = z.enum(configErrorTypeValues);
const ConfigErrorType = configErrorTypeSchema.enum;
type ConfigErrorType = z.infer<typeof configErrorTypeSchema>;

export type ConfigErrors =
  | { errorType: typeof ConfigErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof ConfigErrorType.GLOBAL_APP_SETTING_NOT_FOUND; data: { key: string } }
  | {
      errorType: typeof ConfigErrorType.QUEUE_DEFINITION_NOT_FOUND;
      data: { queueName: string; availableQueues: string[] };
    }
  | { errorType: typeof ConfigErrorType.INNGEST_UNAVAILABLE_IN_TRAINING_SANDBOX; data: undefined };

export const configErrorDetails: Record<ConfigErrorType, ErrorDetails> = {
  UNKNOWN: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Unknown Error" },
  GLOBAL_APP_SETTING_NOT_FOUND: {
    classification: ErrorClassification.UNEXPECTED_ERROR,
    sentryDescription: "Global app setting not found",
  },
  QUEUE_DEFINITION_NOT_FOUND: {
    classification: ErrorClassification.NOT_FOUND_ERROR,
    sentryDescription: "Queue definition not found for the specified queue name",
  },
  INNGEST_UNAVAILABLE_IN_TRAINING_SANDBOX: {
    classification: ErrorClassification.INVALID_STATE_ERROR,
    sentryDescription: "This isn't available in the training sandbox",
  },
};
